(function () {
  function readCssPx(varName) {
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue(varName));
    return Number.isFinite(v) ? v : 0;
  }

  function searchDrawerHasInput(drawer) {
    return !!(drawer && drawer.querySelector('[data-input-search], .t4s-mini-search__frm'));
  }

  function injectSearchSectionHtml(drawer, html) {
    if (!drawer || !html) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var section = tmp.querySelector('.shopify-section') || tmp;
    if (section && section.innerHTML && section.innerHTML.indexOf('t4s-skeleton-element') === -1) {
      drawer.innerHTML = section.innerHTML;
    }
  }

  function fetchSearchDrawerContent(drawer) {
    if (searchDrawerHasInput(drawer)) return Promise.resolve();
    var path = location.pathname || '/';
    var url = path + (location.search ? location.search + '&' : '?') + 'section_id=search-hidden';
    return fetch(url, { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
      .then(function (res) {
        if (res.redirected || !res.ok) throw new Error('search-hidden fetch failed');
        return res.text();
      })
      .then(function (html) {
        injectSearchSectionHtml(drawer, html);
      })
      .catch(function () {
        var root = (window.T4SThemeSP && T4SThemeSP.root_url) || '/';
        return fetch(root + '?section_id=search-hidden', { method: 'GET', headers: { 'Cache-Control': 'no-cache' } })
          .then(function (res) {
            if (res.redirected || !res.ok) return '';
            return res.text();
          })
          .then(function (html) {
            injectSearchSectionHtml(drawer, html);
          })
          .catch(function () {});
      });
  }

  function openSearchDrawer() {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'false');
    fetchSearchDrawerContent(drawer).then(function () {
      drawer.dispatchEvent(new Event('opendDrawer'));
    });
  }

  function closeSearchDrawer() {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;
    drawer.setAttribute('aria-hidden', 'true');
    drawer.dispatchEvent(new Event('opendDrawer'));
  }

  window.__drexeyOpenSearch = function () {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer) return;
    if (drawer.getAttribute('aria-hidden') === 'false') {
      closeSearchDrawer();
      return;
    }
    openSearchDrawer();
  };

  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-drawer-options*="t4s-search-hidden"]');
    if (!trigger) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.__drexeyOpenSearch();
  }, true);

  document.addEventListener('click', function (event) {
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;

    var closeBtn = event.target.closest('.search-close-btn, [data-drawer-close]');
    if (closeBtn && !drawer.contains(closeBtn)) closeBtn = null;
    var overlay = event.target.closest('.t4s-close-overlay');
    var mask = event.target === drawer;
    if (!closeBtn && !overlay && !mask) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    closeSearchDrawer();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.keyCode !== 27) return;
    var drawer = document.getElementById('t4s-search-hidden');
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    closeSearchDrawer();
  });

  if (window.__drexeySearchClickQueued) {
    window.__drexeySearchClickQueued = false;
    window.__drexeyOpenSearch();
  }

  function syncSearchPanelOffset() {
    var offset = 0;
    var annH = 0;
    var ann = document.querySelector('.t4s-announcement-bar');
    if (ann && getComputedStyle(ann).display !== 'none') {
      var annRect = ann.getBoundingClientRect();
      annH = Math.max(0, annRect.height);
      offset = Math.max(offset, annRect.bottom, annH);
    }
    var topbar = document.getElementById('t4s-top-bar-main');
    if (topbar && topbar.offsetParent !== null) {
      offset = Math.max(offset, topbar.getBoundingClientRect().bottom);
    }
    var headerEdge = document.querySelector('.t4s-section-header');
    if (headerEdge) {
      var headerRect = headerEdge.getBoundingClientRect();
      var mobileRow = headerEdge.querySelector('.t4s-header-mobile-row');
      var headerH = headerRect.height;
      if (mobileRow && window.innerWidth <= 990) {
        headerH = Math.max(headerH, mobileRow.getBoundingClientRect().height, 68);
      }
      offset = Math.max(offset, headerRect.bottom, annH + headerH);
    }
    if (!offset) {
      offset = readCssPx('--topbar-height') + readCssPx('--c-h') + readCssPx('--header-height');
    }
    offset = Math.floor(offset);
    document.documentElement.style.setProperty('--mega-menu-offset', offset + 'px');
    document.documentElement.style.setProperty('--header-height', offset + 'px');
    syncSearchBarBottom();
  }

  function syncSearchBarBottom() {
    var drawer = document.querySelector('#t4s-search-hidden.custom-search');
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;

    var bar =
      drawer.querySelector('.t4s-mini-search__btns') ||
      drawer.querySelector('form.t4s-mini-search__frm');
    if (!bar) return;

    var bottom = Math.ceil(bar.getBoundingClientRect().bottom);
    document.documentElement.style.setProperty('--search-bar-bottom', bottom + 'px');
  }

  function setSearchBackdrop(isOpen) {
    var overlay = document.querySelector('.t4s-close-overlay');
    if (!overlay) return;

    if (isOpen) {
      syncSearchPanelOffset();
      overlay.classList.add('is--visible');
      document.body.classList.add('is--opend-drawer');
      return;
    }

    var searchDrawer = document.querySelector('#t4s-search-hidden.custom-search');
    var searchStillOpen =
      searchDrawer && searchDrawer.getAttribute('aria-hidden') === 'false';
    if (searchStillOpen) return;

    var otherDrawerOpen = document.querySelector(
      '.t4s-drawer[aria-hidden="false"]:not(#t4s-search-hidden)'
    );
    if (!otherDrawerOpen) {
      overlay.classList.remove('is--visible');
      document.body.classList.remove('is--opend-drawer');
    }
  }

  function setSearchOpenState(isOpen) {
    document.documentElement.classList.toggle('is-search-open', isOpen);
    document.body.classList.toggle('is-search-open', isOpen);
    document.dispatchEvent(new CustomEvent('drexey:search-toggle', { detail: { isOpen: isOpen } }));
    setSearchBackdrop(isOpen);

    if (!isOpen) {
      document.documentElement.style.removeProperty('--search-bar-bottom');
      return;
    }

    if (window.innerWidth < 1281) {
      syncSearchPanelOffset();
      requestAnimationFrame(function () {
        syncSearchBarBottom();
        focusSearchInput();
      });
      return;
    }

    requestAnimationFrame(function () {
      syncSearchPanelOffset();
      requestAnimationFrame(function () {
        syncSearchPanelOffset();
        syncSearchBarBottom();
        focusSearchInput();
      });
    });
  }

  function focusSearchInput() {
    var input = document.querySelector('#t4s-search-hidden [data-input-search]');
    if (input) input.focus({ preventScroll: true });
  }

  function updateSearchResultsMaxHeight(searchDrawer) {
    var panel = searchDrawer && searchDrawer.querySelector('[data-search-overlay-results]');
    var list = searchDrawer && searchDrawer.querySelector('[data-results-search]');
    if (!panel || panel.hasAttribute('hidden')) return;

    var resultsTop =
      readCssPx('--search-bar-bottom') ||
      readCssPx('--mega-menu-offset') ||
      readCssPx('--header-height') ||
      172;
    var barH = 44;
    var chrome = barH + 12;
    var title = panel.querySelector('[data-title-search]');
    var footer = panel.querySelector('[data-viewAll-search]');
    if (title && title.offsetParent !== null) chrome += title.offsetHeight;
    if (footer && footer.offsetParent !== null) chrome += footer.offsetHeight;

    var maxPanel = window.innerHeight - resultsTop - 8;
    panel.style.maxHeight = Math.max(200, maxPanel) + 'px';
    if (list) list.style.maxHeight = Math.max(140, maxPanel - chrome) + 'px';
  }

  function syncSearchResultsPanel(searchDrawer) {
    if (!searchDrawer) return;
    var panel = searchDrawer.querySelector('[data-search-overlay-results]');
    if (!panel) return;

    var drawerOpen = searchDrawer.getAttribute('aria-hidden') === 'false';
    var hasQueryState =
      searchDrawer.hasAttribute('loading') ||
      searchDrawer.hasAttribute('results') ||
      searchDrawer.hasAttribute('open');

    if (drawerOpen && hasQueryState) {
      panel.removeAttribute('hidden');
      syncSearchPanelOffset();
      requestAnimationFrame(function () {
        syncSearchBarBottom();
        updateSearchResultsMaxHeight(searchDrawer);
      });
    } else {
      panel.setAttribute('hidden', '');
    }
  }

  function onSearchDrawerChange(searchDrawer) {
    var isOpen = searchDrawer.getAttribute('aria-hidden') === 'false';
    setSearchOpenState(isOpen);
    if (isOpen) syncSearchPanelOffset();
    syncSearchResultsPanel(searchDrawer);
  }

  function bindSearchDrawerOverlay() {
    var searchDrawer = document.querySelector('#t4s-search-hidden');
    if (!searchDrawer || searchDrawer.dataset.searchOverlayBound === 'true') return;
    searchDrawer.dataset.searchOverlayBound = 'true';

    onSearchDrawerChange(searchDrawer);

    new MutationObserver(function () {
      onSearchDrawerChange(searchDrawer);
    }).observe(searchDrawer, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'loading', 'results', 'open']
    });

    searchDrawer.addEventListener('opendDrawer', function () {
      onSearchDrawerChange(searchDrawer);
    });

    searchDrawer.addEventListener('search:results-updated', function () {
      syncSearchResultsPanel(searchDrawer);
    });

    new MutationObserver(function () {
      if (searchDrawer.getAttribute('aria-hidden') !== 'false') return;
      syncSearchPanelOffset();
      focusSearchInput();
      syncSearchResultsPanel(searchDrawer);
    }).observe(searchDrawer, { childList: true, subtree: true });
  }

  window.addEventListener('resize', function () {
    var drawer = document.querySelector('#t4s-search-hidden');
    var searchOpen = drawer && drawer.getAttribute('aria-hidden') === 'false';
    if (!searchOpen) return;
    syncSearchPanelOffset();
    syncSearchBarBottom();
    updateSearchResultsMaxHeight(drawer);
  }, { passive: true });

  function clearStaleSearchSectionCache() {
    try {
      var prefix = 'dataSearchT4s';
      for (var i = sessionStorage.length - 1; i >= 0; i--) {
        var key = sessionStorage.key(i);
        if (key && key.indexOf(prefix) === 0 && key.indexOf('dataSearchT4sV5') !== 0) {
          sessionStorage.removeItem(key);
        }
      }
    } catch (e) {}
  }

  clearStaleSearchSectionCache();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindSearchDrawerOverlay);
  } else {
    bindSearchDrawerOverlay();
  }
})();
